<template>
    <section class="content">
        <div class="">
            <div class="container-fluid">
                <h6 class="font-weight-bold mb-4">Detail Data Pelanggan</h6>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="small-box bg-pel-aktif shadow rounded">
                            <div class="inner p-3">
                                <h3 class="font-weight-bold">{{ pelanggan.aktif }}</h3>
                                <p class="mb-1">Pelanggan Aktif</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-users"></i>
                            </div>
                            <a href="#" class="small-box-footer">Info <i class="fas fa-arrow-circle-right"></i></a>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="small-box bg-pel-isolir shadow rounded">
                            <div class="inner p-3">
                                <h3 class="font-weight-bold">{{ pelanggan.isolir }}</h3>
                                <p class="mb-1">Pelanggan Isolir</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-users-slash"></i>
                            </div>
                            <a href="#" class="small-box-footer">-</a>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="small-box bg-pel-dismantled shadow rounded">
                            <div class="inner p-3">
                                <h3 class="font-weight-bold">{{ pelanggan.nonaktif }}</h3>
                                <p class="mb-1">Pelanggan Dismantled</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-user-times"></i>
                            </div>
                            <a href="#" class="small-box-footer">Info </a>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="small-box bg-pel-baru shadow rounded">
                            <div class="inner p-3">
                                <h3 class="font-weight-bold">{{ pelanggan.pelanggan_baru }}</h3>
                                <p class="mb-1">Pelanggan Baru</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-user-check"></i>
                            </div>
                            <a href="#" class="small-box-footer">Info <i class="fas fa-arrow-circle-right"></i></a>
                        </div>
                    </div>
                </div>

                <h6>Detail Tagihan</h6>
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-tag-brutto">
                            <div class="inner">
                                <h3>{{ tagihan.total_tagihan_bruto }}</h3>
                                <p>Tagihan Brutto Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-money-bill-wave-alt"></i>
                            </div>
                            <a href="#" class="small-box-footer">&nbsp;</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-pjk-tidak-ada">
                            <div class="inner">
                                <h3>{{ tagihan.pajak_tidak_dipungut }}</h3>
                                <p>Pajak Tidak Dipungut</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-tags"></i>
                            </div>
                            <a href="#" class="small-box-footer">&nbsp;</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-tag-nett">
                            <div class="inner">
                                <h3>{{ tagihan.total_tagihan_bersih }}</h3>
                                <p>Tagihan Nett Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-cash-register"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <h6>Data Tagihan Brutto</h6>
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-tag-over">
                            <div class="inner">
                                <h3>{{ tagihan.total_tagihan_bruto }}</h3>
                                <p>Tagihan Brutto Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-money-bill-wave-alt"></i>
                            </div>
                            <a href="#" class="small-box-footer">&nbsp;</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-lime">
                            <div class="inner">
                                <h3>{{ tagihan.penerimaan_brutto }}</h3>
                                <p>Penerimaan Brutto Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-check-circle"></i>
                            </div>
                            <a href="#" class="small-box-footer">&nbsp;</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{ tagihan.penerimaan_brutto }}</h3>
                                <p>Sisa Tagihan Brutto Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-exclamation"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <h6>Data Tagihan Nett</h6>
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-warning">
                            <div class="inner">
                                <h3>{{ tagihan.total_tagihan_bersih }}</h3>
                                <p>Tagihan Nett Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-cash-register"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-lime">
                            <div class="inner">
                                <h3>{{ tagihan.penerimaan_bersih }}</h3>
                                <p>Penerimaan Nett Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-check-circle"></i>
                            </div>
                            <a href="#" class="small-box-footer">&nbsp;</a>
                        </div>
                    </div>

                    <div class="col-lg-4 col-12">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{ tagihan.sisa_tagihan_bersih }}</h3>
                                <p>Sisa Tagihan Nett Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-exclamation"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <h6>Tagihan Overdue Brutto</h6>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{ formatRupiah(overdue.brutto_overdue_unpaid) }}</h3>
                                <p>Overdue</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-exclamation-triangle"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-lime">
                            <div class="inner">
                                <h3>{{ formatRupiah(overdue.brutto_overdue_paid) }}</h3>
                                <p>Pelunasan Overdue Dalam Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-wallet"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <h6>Tagihan Overdue Nett</h6>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{ formatRupiah(overdue.net_overdue_unpaid) }}</h3>
                                <p>Overdue</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-exclamation-triangle"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-lime">
                            <div class="inner">
                                <h3>{{ formatRupiah(overdue.net_overdue_paid) }}</h3>
                                <p>Pelunasan Overdue Dalam Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-wallet"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <h6>Penerimaan Total Bulan Ini</h6>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-teal disabled color-palette">
                            <div class="inner">
                                <h3>{{ formatRupiah(brutto_total_penerimaan) }}</h3>
                                <p>Penerimaan Brutto Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-check-circle"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-12">
                        <div class="small-box bg-olive disabled color-palette">
                            <div class="inner">
                                <h3>{{ formatRupiah(net_total_penerimaan) }}</h3>
                                <p>Penerimaan Nett Bulan Ini</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-wallet"></i>
                            </div>
                            <a href="#" class="small-box-footer">info</a>
                        </div>
                    </div>
                </div>

                <template>
                    <div class="row " v-if="roleId < 4">
                        <div class="col-md-12">
                            <div class="card card-info">
                                <div class="card-header">
                                    <h3 class="card-title">Rekap Tagihan</h3>
                                </div>
                                <div class="card-body">
                                    <div class="table-wrapper"
                                        style="width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch;">
                                        <table
                                            style="font-size: 12px !important; min-width: 900px; padding: 6px 5px !important;"
                                            class="table table-bordered table-striped table-rekap">
                                            <thead>
                                                <tr>
                                                    <th rowspan="2" class="text-center align-middle">No</th>
                                                    <th rowspan="2" class="text-center align-middle">Nama Cabang</th>
                                                    <th rowspan="2" class="text-center align-middle">Bulan</th>
                                                    <th rowspan="2" class="text-center align-middle">Tahun</th>
                                                    <th colspan="3" class="text-center">Total</th>
                                                    <th colspan="3" class="text-center">Lunas</th>
                                                    <th colspan="3" class="text-center">Sisa</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-right">Jlh</th>
                                                    <th class="text-right">Brutto</th>
                                                    <th class="text-right">Nett</th>
                                                    <th class="text-right">Jlh</th>
                                                    <th class="text-right">Brutto</th>
                                                    <th class="text-right">Nett</th>
                                                    <th class="text-right">Jlh</th>
                                                    <th class="text-right">Brutto</th>
                                                    <th class="text-right">Nett</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in rekapTagihanGrouped" :key="index">
                                                    <td class="text-center align-middle">{{ item.no }}</td>
                                                    <td>{{ item.kantor }} <span v-if="item.jenis !== 'PPOE'">{{
                                                        item.jenis }}</span></td>
                                                    <td class="text-center">{{ item.bulan }}</td>
                                                    <td class="text-center">{{ item.tahun }}</td>
                                                    <td class="text-right">{{ item.jumlah_aktif }}</td>
                                                    <td class="text-right">{{ formatRupiah(item.total_tagihan_bruto) }}
                                                    </td>
                                                    <td class="text-right">{{ formatRupiah(item.total_tagihan_netto) }}
                                                    </td>
                                                    <td class="text-right">{{ item.jumlah_sudah_bayar }}</td>
                                                    <td class="text-right">{{ formatRupiah(item.total_bruto_sudah_bayar)
                                                    }}</td>
                                                    <td class="text-right">{{ formatRupiah(item.total_netto_sudah_bayar)
                                                    }}</td>
                                                    <td class="text-right">{{ item.jumlah_sisa_bayar }}</td>
                                                    <td class="text-right">{{ formatRupiah(item.total_bruto_sisa_bayar)
                                                    }}</td>
                                                    <td class="text-right">{{ formatRupiah(item.total_netto_sisa_bayar)
                                                    }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="row" v-if="roleId < 4">
                    <div class="col-12">
                        <div class="card card-info">
                            <div class="card-header">
                                <h3 class="card-title">Grafik Tagihan Dan Pelunasan Cabang (Brutto)</h3>
                            </div>
                            <div class="card-body">
                                <div class="container-fluid">
                                    <div style="width: 100%; height: 300px;">
                                        <canvas ref="chartCanvas"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="roleId < 4">
                    <div class="col-12">
                        <div class="card card-info">
                            <div class="card-header">
                                <h3 class="card-title">Grafik Tagihan Dan Pelunasan Cabang (Brutto)</h3>
                            </div>
                            <div class="card-body">
                                <div class="container-fluid">
                                    <div style="width: 100%; height: 300px;">
                                        <canvas ref="areaChartCanvas"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="roleId < 4">
                    <div class="col-12">
                        <div class="card card-info">
                            <div class="card-header">
                                <h3 class="card-title">Aktivasi Layanan</h3>
                            </div>
                            <div class="card-body">
                                <div class="container-fluid">
                                    <div style="width: 100%; height: 300px;">
                                        <canvas ref="donutChartCanvas"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Bar, Line, Doughnut } from "vue-chartjs";
import Chart from "chart.js";
import axios from "axios";

export default {
    components: {
        "bar-chart": Bar,
        "area-chart": Line,
        "donut-chart": Doughnut,
    },

    data() {
        return {
            tabRekap: 'ppoe',
            pelanggan: {},
            tagihan: {},
            rekap_tagihan: [],
            labels: [],
            tagihanData: [],
            pelunasanData: [],
            labelsArea: [],
            pertumbuhanData: [],
            chart: null,
            chartArea: null,
            donutChart: null,
            labelPaket: [],
            peketData: [],
            roleId: this.$gate.user.roles.id,
            overdue: {},
            brutto_total_penerimaan: 0,
            net_total_penerimaan: 0,
        };
    },

    methods: {
        async fetchData() {
            try {
                const { data } = await axios.get("api/dashboard/detailPelanggan");
                if (!data.success) return;

                this.pelanggan = this.parsePelangganData(data.data.pelanggan);
                this.tagihan = this.parseTagihanData(data.data.tagihan);
                this.rekap_tagihan = data.data.rekap_tagihan;
                this.overdue = data.data.overdue;
                this.brutto_total_penerimaan = data.data.tagihan.total_penerimaan_bruto_bulan_ini + data.data.overdue.brutto_overdue_paid;
                this.net_total_penerimaan = data.data.tagihan.total_penerimaan_bersih_bulan_ini + data.data.overdue.net_overdue_paid;
                this.processChartData(data.data.grafik_tagihan.original || [], data.data.grafik_pertumbuhan_pelanggan.original || [], data.data.grafik_aktivasi_layanan.original || []);

                this.$nextTick(() => {
                    this.createChart();
                    this.createAreaChart();
                    this.createDonutChart();
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },

        parsePelangganData(pelanggan) {
            return Object.fromEntries(Object.entries(pelanggan).map(([key, value]) => [key, Number(value)]));
        },

        parseTagihanData(tagihan) {
            return Object.fromEntries(Object.entries(tagihan).map(([key, value]) => [key, this.formatRupiah(value)]));
        },

        processChartData(grafikTagihan, grafikPertumbuhanPelanggan, grafikAktivasiLayanan) {
            this.labels = grafikTagihan.map(item => item.value);
            this.tagihanData = grafikTagihan.map(item => item.total_tagihan_bruto);
            this.pelunasanData = grafikTagihan.map(item => item.total_bruto_sudah_bayar);
            this.labelsArea = grafikPertumbuhanPelanggan.map(item => item.bulan);
            this.pertumbuhanData = grafikPertumbuhanPelanggan.map(item => item.total_pelanggan_baru);
            this.labelPaket = grafikAktivasiLayanan.map(item => item.paket);
            this.paketData = grafikAktivasiLayanan.map(item => item.total_aktivasi);

        },

        formatRupiah(value) {
            if (!value) return "Rp.0";
            return `Rp. ${Number(value).toLocaleString("id-ID").replace(/,/g, ".")}`;
        },

        createChart() {
            this.destroyChart(this.chart);
            const ctx = this.$refs.chartCanvas.getContext("2d");

            this.chart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels: this.labels,
                    datasets: [
                        {
                            label: "Tagihan",
                            backgroundColor: "rgba(255, 104, 107, 0.7)", // Transparan
                            borderColor: "#ff686b",
                            borderWidth: 2,
                            borderRadius: 8, // Smooth effect
                            data: this.tagihanData
                        },
                        {
                            label: "Pelunasan",
                            backgroundColor: "rgba(132, 220, 198, 0.7)", // Transparan
                            borderColor: "#84dcc6",
                            borderWidth: 2,
                            borderRadius: 8, // Smooth effect
                            data: this.pelunasanData
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 800, // Animasi lebih smooth
                        easing: "easeInOutQuad"
                    },
                    scales: {
                        x: {
                            grid: { display: false },
                            ticks: { font: { size: 14, weight: "bold" } }
                        },
                        y: {
                            grid: {
                                color: "rgba(0, 0, 0, 0.1)", // Grid lebih soft
                                borderDash: [5, 5]
                            },
                            ticks: {
                                beginAtZero: true,
                                font: { size: 12 }
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                font: { size: 14, weight: "bold" },
                                color: "#333"
                            }
                        },
                        tooltip: {
                            backgroundColor: "#222",
                            titleFont: { size: 14, weight: "bold" },
                            bodyFont: { size: 12 },
                            cornerRadius: 8
                        }
                    }
                }
            });
        },

        createAreaChart() {
            this.destroyChart(this.chartArea);
            const ctx = this.$refs.areaChartCanvas.getContext("2d");

            // Efek gradasi untuk area chart
            const gradient = ctx.createLinearGradient(0, 0, 0, 400);
            gradient.addColorStop(0, "rgba(54, 162, 235, 0.5)");
            gradient.addColorStop(1, "rgba(54, 162, 235, 0)");

            this.chartArea = new Chart(ctx, {
                type: "line",
                data: {
                    labels: this.labelsArea,
                    datasets: [
                        {
                            label: "Pelanggan Baru",
                            data: this.pertumbuhanData,
                            backgroundColor: gradient, // Gunakan efek gradasi
                            borderColor: "#36A2EB",
                            borderWidth: 2,
                            pointRadius: 4, // Titik lebih jelas
                            pointBackgroundColor: "#36A2EB",
                            pointBorderColor: "#fff",
                            fill: true,
                            tension: 0.3 // Smooth effect
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 1000, // Animasi lebih smooth
                        easing: "easeInOutQuad"
                    },
                    scales: {
                        x: {
                            grid: { display: false },
                            ticks: { font: { size: 14, weight: "bold" } }
                        },
                        y: {
                            grid: {
                                color: "rgba(0, 0, 0, 0.1)", // Grid lebih soft
                                borderDash: [5, 5]
                            },
                            ticks: {
                                beginAtZero: true,
                                font: { size: 12 }
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                font: { size: 14, weight: "bold" },
                                color: "#333"
                            }
                        },
                        tooltip: {
                            backgroundColor: "#222",
                            titleFont: { size: 14, weight: "bold" },
                            bodyFont: { size: 12 },
                            cornerRadius: 8
                        }
                    }
                }
            });
        },

        createDonutChart() {
            this.destroyChart("donutChart");

            const fixedColors = [
                "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
                "#FF9F40", "#C9CBCF", "#2E86C1", "#D4AC0D", "#28B463"
            ];

            const ctx = this.$refs.donutChartCanvas.getContext("2d");

            this.donutChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: this.labelPaket,
                    datasets: [
                        {
                            data: this.paketData,
                            backgroundColor: fixedColors.slice(0, this.paketData.length),
                            borderColor: "#fff", // Border putih untuk lebih clean
                            borderWidth: 2,
                            hoverOffset: 8 // Efek hover lebih smooth
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: "65%", // Ukuran lubang tengah untuk tampilan modern
                    plugins: {
                        legend: {
                            position: "bottom",
                            labels: {
                                font: { size: 14, weight: "bold" },
                                color: "#333"
                            }
                        },
                        tooltip: {
                            backgroundColor: "#222",
                            titleFont: { size: 14, weight: "bold" },
                            bodyFont: { size: 12 },
                            cornerRadius: 8
                        },
                        datalabels: {
                            color: "#fff",
                            font: { size: 14, weight: "bold" },
                            formatter: (value, context) => {
                                let total = context.dataset.data.reduce((a, b) => a + b, 0);
                                let percentage = ((value / total) * 100).toFixed(1) + "%";
                                return percentage;
                            }
                        }
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    }
                }
            });
        },

        destroyChart(chartRef) {
            if (this[chartRef]) {
                this[chartRef].destroy();
                this[chartRef] = null;
            }
        }

    },

    mounted() {
        this.fetchData();
    },
    computed: {
        rekapTagihanGrouped() {
            let result = [];
            let no = 1;
            let currentKantor = null;
            let currentGroupIndex = -1;

            this.rekap_tagihan.forEach(item => {
                if (item.kantor !== currentKantor) {
                    currentKantor = item.kantor;
                    currentGroupIndex = result.length;
                    result.push({
                        ...item,
                        showNo: true,
                        rowspan: 1,
                        no: no++
                    });
                } else {
                    result[currentGroupIndex].rowspan += 1;
                    result.push({
                        ...item,
                        showNo: true,
                        rowspan: 1,
                        no: no++
                    });
                }
            });

            return result;
        },
        rekapPpoe() {
            return this.rekap_tagihan.filter(i => i.jenis === 'PPOE')
        },
        rekapCorporate() {
            return this.rekap_tagihan.filter(i => i.jenis === 'CORPORATE')
        }
    }
};
</script>

<style scoped>
.text-wrap {
    word-break: break-word;
    white-space: normal;
}

table {
    width: max-content;
    /* Agar tabel bisa lebar tanpa memaksa container */
    min-width: 100%;
    /* Agar tidak terlalu kecil */
    border-collapse: collapse;
}

thead {
    position: sticky;
    top: 0;
    /* background-color: #343a40; */
    /* color: white; */
}

.small-box {
    position: relative;
    border-radius: 10px;
    /* Border radius lebih kecil agar tidak terlalu kaku */
    padding: 20px;
    color: #ffffff;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* Hover lebih smooth */
.small-box:hover {
    transform: translateY(-3px);
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
}

/* Background warna */
.bg-pel-aktif {
    background: linear-gradient(135deg, #2ecc71, #27ae60);
}

.bg-pel-isolir {
    background: linear-gradient(135deg, #f39c12, #e67e22);
}

.bg-pel-dismantled {
    background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.bg-pel-baru {
    background: linear-gradient(135deg, #3498db, #2980b9);
}

/* Inner Box */
.small-box .inner {
    text-align: left;
    /* Rata kiri supaya tidak kaku */
    padding: 10px;
}

/* Teks */
.small-box .inner h3 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 5px;
}

.small-box .inner p {
    font-size: 1rem;
    opacity: 0.9;
    margin: 0;
}

/* Ikon */
.small-box .icon {
    font-size: 4rem;
    opacity: 0.2;
    position: absolute;
    top: 10px;
    right: 15px;
}

/* Footer */
.small-box-footer {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    display: block;
    /* padding: 10px; */
    text-align: center;
    font-weight: bold;
    transition: background 0.3s ease-in-out;
    border-radius: 0 0 10px 10px;
}

.small-box-footer:hover {
    background: rgba(255, 255, 255, 0.3);
    text-decoration: none;
}

.table-rekap {
    width: 100% !important;
    table-layout: auto;
}

.table-rekap td {
    padding: 6px 8px !important;
    white-space: nowrap;
}

.table-rekap th {
    padding: 6px 8px !important;
}
</style>